import $ from "jQuery";

var backToTop = $(".back-to-top__button");
backToTop.on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({scrollTop:0}, '500');
});